import { getSheetIndex, isHiddenRow, getCell, setCell, getSheet } from '../../workbook/index';
import { initiateChart, getRangeIndexes, isNumber, getSheetIndexFromAddress } from '../../workbook/index';
import { refreshChartCellOnInit } from '../../workbook/index';
import { overlay, locale, refreshChartCellObj, getRowIdxFromClientY, getColIdxFromClientX, deleteChart, dialog, overlayEleSize, undoRedoForChartDesign, refreshChartCellModel } from '../common/index';
import { completeAction, clearChartBorder, focusBorder } from '../common/index';
import { Chart, ColumnSeries, Category, StackingColumnSeries, BarSeries, DateTime } from '@syncfusion/ej2-charts';
import { AreaSeries, StackingAreaSeries, AccumulationChart, Tooltip } from '@syncfusion/ej2-charts';
import { Legend, StackingBarSeries, LineSeries, StackingLineSeries, ScatterSeries } from '@syncfusion/ej2-charts';
import { AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel } from '@syncfusion/ej2-charts';
import { isNullOrUndefined, getComponent, closest, detach, isUndefined, getUniqueID } from '@syncfusion/ej2-base';
import { isCustomDateTime, getAutoDetectFormatParser, calculateFormula, checkRange, inRange } from '../../workbook/index';
import { refreshChart, deleteChartColl, getFormattedCellObject, setChart, getCellAddress, skipHiddenIdx, addDPRValue, dateToInt, getRangeFromAddress, getRangeAddress } from '../../workbook/common/index';
import { insertChart, chartRangeSelection, chartDesignTab, removeDesignChart, insertDesignChart, getUpdateUsingRaf, focus } from '../common/index';
import { DataLabel } from '@syncfusion/ej2-charts';
import { isHiddenCol, beginAction } from '../../workbook/index';
Chart.Inject(ColumnSeries, LineSeries, BarSeries, AreaSeries, StackingColumnSeries, StackingLineSeries, StackingBarSeries, ScatterSeries);
Chart.Inject(StackingAreaSeries, Category, Legend, Tooltip, DataLabel, DateTime);
AccumulationChart.Inject(PieSeries, AccumulationTooltip, AccumulationDataLabel, AccumulationLegend);
/**
 * Represents Chart support for Spreadsheet.
 */
var SpreadsheetChart = /** @class */ (function () {
    /**
     * Constructor for the Spreadsheet Chart module.
     *
     * @param {Spreadsheet} parent - Constructor for the Spreadsheet Chart module.
     */
    function SpreadsheetChart(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * Adding event listener for success and failure
     *
     * @returns {void} - Adding event listener for success and failure
     */
    SpreadsheetChart.prototype.addEventListener = function () {
        this.parent.on(initiateChart, this.initiateChartHandler, this);
        this.parent.on(refreshChartCellObj, this.refreshChartCellObj, this);
        this.parent.on(refreshChartCellModel, this.refreshChartCellModel, this);
        this.parent.on(refreshChartCellOnInit, this.refreshChartCellObj, this);
        this.parent.on(deleteChart, this.deleteChart, this);
        this.parent.on(clearChartBorder, this.clearBorder, this);
        this.parent.on(insertChart, this.insertChartHandler, this);
        this.parent.on(chartRangeSelection, this.chartRangeHandler, this);
        this.parent.on(chartDesignTab, this.chartDesignTabHandler, this);
        this.parent.on(undoRedoForChartDesign, this.undoRedoForChartDesign, this);
        this.parent.on(refreshChart, this.refreshChartData, this);
    };
    SpreadsheetChart.prototype.insertChartHandler = function (args) {
        var _this = this;
        var chartType = 'Column';
        var markerVisible = false;
        switch (args.id) {
            case 'clusteredColumn':
                chartType = 'Column';
                break;
            case 'stackedColumn':
                chartType = 'StackingColumn';
                break;
            case 'stackedColumn100':
                chartType = 'StackingColumn100';
                break;
            case 'clusteredBar':
                chartType = 'Bar';
                break;
            case 'stackedBar':
                chartType = 'StackingBar';
                break;
            case 'stackedBar100':
                chartType = 'StackingBar100';
                break;
            case 'area':
                chartType = 'Area';
                break;
            case 'stackedArea':
                chartType = 'StackingArea';
                break;
            case 'stackedArea100':
                chartType = 'StackingArea100';
                break;
            case 'line':
                chartType = 'Line';
                break;
            case 'lineMarker':
                chartType = 'Line';
                markerVisible = true;
                break;
            case 'stackedLine':
                chartType = 'StackingLine';
                break;
            case 'stackedLineMarker':
                chartType = 'StackingLine';
                markerVisible = true;
                break;
            case 'stackedLine100':
                chartType = 'StackingLine100';
                break;
            case 'stackedLine100Marker':
                chartType = 'StackingLine100';
                markerVisible = true;
                break;
            case 'pie':
                chartType = 'Pie';
                break;
            case 'doughnut':
                chartType = 'Doughnut';
                break;
            //  case 'radar':
            //     chartType = ;
            //     break;
            //  case 'radar_markers':
            //     chartType = 'Column';
            //     break;
            case 'scatter':
                chartType = 'Scatter';
                break;
        }
        var chart = [{ type: chartType, markerSettings: { visible: markerVisible, isFilled: true } }];
        if (args.isChart) {
            this.parent.notify(setChart, { chart: chart });
            getUpdateUsingRaf(function () { return focus(_this.parent.element); });
        }
        else {
            this.parent.notify(chartDesignTab, { chartType: chartType, triggerEvent: true, markerVisible: markerVisible });
        }
    };
    SpreadsheetChart.prototype.chartRangeHandler = function () {
        var overlayEle = document.querySelector('.e-datavisualization-chart.e-ss-overlay-active');
        if (overlayEle) {
            var chartId = overlayEle.getElementsByClassName('e-control')[0].id;
            var chartColl = this.parent.chartColl;
            var chartCollLen = chartColl.length;
            for (var idx = 0; idx < chartCollLen; idx++) {
                var chartEle = document.getElementById(chartColl[idx].id);
                if (overlayEle && chartEle && chartColl[idx].id === chartId) {
                    this.initiateChartHandler({ option: chartColl[idx], isRefresh: true });
                }
            }
        }
    };
    SpreadsheetChart.prototype.refreshChartData = function (args) {
        if (!this.parent.chartColl || !this.parent.chartColl.length) {
            return;
        }
        var chart;
        var sheetName;
        var range;
        var insideRange;
        var chartEle;
        var chartObj;
        for (var i = 0, len = this.parent.chartColl.length; i < len; i++) {
            chart = this.parent.chartColl[i];
            if (!chart.range) {
                continue;
            }
            if (chart.range.includes('!')) {
                sheetName = chart.range.substring(0, chart.range.lastIndexOf('!'));
                if (this.parent.activeSheetIndex !== getSheetIndex(this.parent, sheetName)) {
                    continue;
                }
                range = chart.range.substring(chart.range.lastIndexOf('!') + 1);
            }
            else {
                range = chart.range;
            }
            if (args.viewportIndexes) {
                for (var idx = 0; idx < args.viewportIndexes.length; idx++) {
                    var rangeParts = range.split(/\s+/);
                    for (var partIdx = 0; partIdx < rangeParts.length; partIdx++) {
                        if (checkRange([args.viewportIndexes[idx]], rangeParts[partIdx])) {
                            insideRange = true;
                            break;
                        }
                    }
                    if (insideRange) {
                        break;
                    }
                }
            }
            else {
                var rangeParts = range.split(/\s+/);
                for (var partIdx = 0; partIdx < rangeParts.length; partIdx++) {
                    var rangeIndexes = getRangeIndexes(rangeParts[partIdx]);
                    if (args.range) {
                        if (checkRange([args.range], rangeParts[partIdx])) {
                            insideRange = true;
                            break;
                        }
                    }
                    else if (args.showHide) {
                        if (this.inRowColumnRange(rangeIndexes, args.rIdx, args.showHide)) {
                            insideRange = true;
                            break;
                        }
                    }
                    else {
                        if (inRange(rangeIndexes, args.rIdx, args.cIdx)) {
                            insideRange = true;
                            break;
                        }
                    }
                }
            }
            if (insideRange || (args.isSelectAll && !args.isRefreshChart)) {
                chartEle = this.parent.element.querySelector('.' + chart.id);
                if (chartEle) {
                    chartObj = getComponent(chartEle, 'chart') || getComponent(chartEle, 'accumulationchart');
                    if (chartObj) {
                        chartObj.series = this.initiateChartHandler({ option: chart, isRefresh: true });
                        chartObj.refresh();
                    }
                }
            }
        }
    };
    SpreadsheetChart.prototype.inRowColumnRange = function (range, index, showHide) {
        return showHide === 'rows' ? index >= range[0] && index <= range[2] : index >= range[1] && index <= range[3];
    };
    SpreadsheetChart.prototype.refreshChartCellModel = function (args) {
        for (var i = 0, len = args.prevChartIndexes.length; i < len; i++) {
            var chart = args.prevChartIndexes[i].chart;
            var prevRowIdx = args.prevChartIndexes[i].chartRowIdx;
            var prevColIdx = args.prevChartIndexes[i].chartColIdx;
            var currentRowIdx = args.currentChartIndexes[i].chartRowIdx;
            var currentColIdx = args.currentChartIndexes[i].chartColIdx;
            var eventArgs = {
                prevTop: chart.top, prevLeft: chart.left, prevRowIdx: prevRowIdx, prevColIdx: prevColIdx,
                prevHeight: chart.height, prevWidth: chart.width, currentTop: chart.top, currentLeft: chart.left,
                currentRowIdx: currentRowIdx, currentColIdx: currentColIdx, currentHeight: chart.height,
                currentWidth: chart.width, id: chart.id, requestType: 'chartRefreshOnFilter'
            };
            this.parent.notify(refreshChartCellObj, eventArgs);
        }
    };
    SpreadsheetChart.prototype.refreshChartCellObj = function (args) {
        var sheetIndex = isUndefined(args.sheetIdx) ? this.parent.activeSheetIndex : args.sheetIdx;
        var sheet = getSheet(this.parent, sheetIndex);
        var prevCellObj = getCell(args.prevRowIdx, args.prevColIdx, sheet);
        var currCellObj = getCell(args.currentRowIdx, args.currentColIdx, sheet);
        var prevCellChart = prevCellObj ? prevCellObj.chart : [];
        var prevChartObj;
        var currChartObj;
        var prevCellChartLen = (prevCellChart && prevCellChart.length) ? prevCellChart.length : 0;
        if (prevCellChartLen) {
            for (var i = 0; i < prevCellChartLen; i++) {
                if (prevCellChart[i].id === args.id.split('_overlay')[0]) {
                    prevChartObj = prevCellChart[i];
                    prevChartObj.height = args.currentHeight;
                    prevChartObj.width = args.currentWidth;
                    prevChartObj.top = args.currentTop;
                    prevChartObj.left = args.currentLeft;
                    prevChartObj.address = [args.currentRowIdx, args.currentColIdx];
                    prevCellChart.splice(i, 1);
                    i--;
                    prevCellChartLen--;
                    for (var idx = 0, chartCollLen = this.parent.chartColl.length; idx < chartCollLen; idx++) {
                        if (prevChartObj.id === this.parent.chartColl[idx].id) {
                            prevChartObj.height = args.currentHeight;
                            this.parent.chartColl[idx].width = args.currentWidth;
                            this.parent.chartColl[idx].height = args.currentHeight;
                            this.parent.chartColl[idx].top = args.currentTop;
                            this.parent.chartColl[idx].left = args.currentLeft;
                            this.parent.chartColl[idx].address = prevChartObj.address;
                        }
                    }
                }
            }
            if (currCellObj && currCellObj.chart) {
                currChartObj = currCellObj.chart;
                if (prevChartObj) {
                    currChartObj.push(prevChartObj);
                }
            }
            if (currChartObj) {
                setCell(args.currentRowIdx, args.currentColIdx, sheet, { chart: currChartObj }, true);
            }
            else {
                setCell(args.currentRowIdx, args.currentColIdx, sheet, { chart: [prevChartObj] }, true);
            }
            if (args.requestType === 'chartRefresh' && !args.isUndoRedo) {
                var eventArgs = {
                    requestType: 'chartRefresh', currentRowIdx: args.currentRowIdx, currentColIdx: args.currentColIdx,
                    currentWidth: args.currentWidth, prevHeight: args.prevHeight, prevWidth: args.prevWidth,
                    prevRowIdx: args.prevRowIdx, prevColIdx: args.prevColIdx, prevTop: args.prevTop, prevLeft: args.prevLeft,
                    currentTop: args.currentTop, currentLeft: args.currentLeft, currentHeight: args.currentHeight,
                    id: args.id, sheetIdx: sheetIndex
                };
                this.parent.notify('actionComplete', { eventArgs: eventArgs, action: 'chartRefresh' });
            }
        }
        if (args.isUndoRedo && sheetIndex === this.parent.activeSheetIndex) {
            var overlayEle = document.getElementById(args.id);
            if (overlayEle) {
                overlayEle.style.height = args.currentHeight + "px";
                overlayEle.style.width = args.currentWidth + "px";
                var frozenRow = this.parent.frozenRowCount(sheet);
                var frozenCol = this.parent.frozenColCount(sheet);
                if (frozenRow || frozenCol) {
                    if (args.currentRowIdx < frozenRow || args.currentColIdx < frozenCol) {
                        this.parent.element.querySelector('#' + this.parent.element.id + '_sheet').appendChild(overlayEle);
                    }
                    else {
                        this.parent.getMainContent().appendChild(overlayEle);
                    }
                    this.parent.serviceLocator.getService(overlay).adjustFreezePaneSize({ top: args.currentTop, left: args.currentLeft }, overlayEle, getCellAddress(args.currentRowIdx, args.currentColIdx));
                    var chartEle = overlayEle.querySelector('.e-chart');
                    if (chartEle) {
                        focus(chartEle);
                    }
                }
                else {
                    overlayEle.style.top = args.currentTop + "px";
                    overlayEle.style.left = args.currentLeft + "px";
                }
            }
        }
    };
    SpreadsheetChart.prototype.processChartRange = function (range, dataSheetIdx, opt, isDiscontinuousRange, hasLabel) {
        var _this = this;
        var xRange;
        var yRange;
        var lRange;
        var isDateTimeFormat;
        var isDateTime;
        var minr = range[0];
        var minc = range[1];
        var maxr = range[2];
        var maxc = range[3];
        var isSingleRow = minr === maxr;
        var isSingleCol = minc === maxc;
        var sheet = getSheet(this.parent, dataSheetIdx);
        var autoDetectFormatFn = getAutoDetectFormatParser(this.parent);
        var getPropertyValue = function (rIdx, cIdx, isFirstCol, checkDateTime) {
            var cell = getCell(rIdx, cIdx, sheet);
            if (cell) {
                if (cell.formula && isNullOrUndefined(cell.value)) {
                    _this.parent.notify(calculateFormula, { cell: cell, rowIdx: rIdx, colIdx: cIdx, sheetIndex: dataSheetIdx });
                }
                var value = void 0;
                if (cell.format) {
                    var formatObj = { value: cell.value, format: cell.format, formattedText: cell.value, cell: cell,
                        rowIndex: rIdx, colIndex: cIdx };
                    _this.parent.notify(getFormattedCellObject, formatObj);
                    var isNum = isNumber(cell.value);
                    if (isNum && !isCustomDateTime(cell.format, true, null, true)) {
                        value = Number(cell.value);
                    }
                    else {
                        if (checkDateTime && isNum) {
                            isDateTimeFormat = true;
                        }
                        else if (isFirstCol && isNum) {
                            isDateTime = true;
                        }
                        value = formatObj.formattedText && formatObj.formattedText.toString();
                    }
                }
                else {
                    autoDetectFormatFn(cell);
                    value = cell.value;
                }
                return isNullOrUndefined(value) ? '' : value;
            }
            else {
                return '';
            }
        };
        var updatePieChartRange = function (startMinCol, startMinRow) {
            var stringColIdx;
            var numericColIdx;
            var isStringDetected;
            var startRowIdx = startMinRow === undefined ? minr : startMinRow;
            for (var colIdx = startMinCol; colIdx < maxc; colIdx++) {
                var cell_1 = getCell(startRowIdx, colIdx, sheet);
                if (cell_1) {
                    if ((numericColIdx === undefined || isStringDetected) && isNumber(cell_1.value)) {
                        numericColIdx = colIdx;
                        isStringDetected = false;
                    }
                    var isDateTimeFormat_1 = cell_1.format && isCustomDateTime(cell_1.format, true, null, true);
                    if (!isNumber(cell_1.value) || isDateTimeFormat_1) {
                        stringColIdx = colIdx;
                        isStringDetected = true;
                        if (isDateTimeFormat_1 && colIdx === maxc - 1) {
                            numericColIdx = maxc;
                        }
                    }
                }
            }
            xRange = [startRowIdx, minc, maxr, stringColIdx ? stringColIdx : minc];
            yRange = [startRowIdx, numericColIdx ? numericColIdx : maxc, maxr, maxc];
            if (startMinRow !== undefined) {
                lRange = [minr, numericColIdx ? numericColIdx : maxc, minr, maxc];
            }
        };
        var trVal = sheet ? getPropertyValue(minr, maxc, false, true) : '';
        var blVal = sheet ? getPropertyValue(maxr, minc, true) : '';
        var tlVal = sheet ? getPropertyValue(minr, minc, true) : '';
        var isCellFormat = false;
        var isStringSeries = false;
        var cell = getCell(minr, minc, sheet);
        isCellFormat = (cell && cell.format) ? true : false;
        var isNumberBool = this.isNumberOrNot(minr, minc, maxr, maxc, sheet);
        if ((!isNumber(blVal) || !tlVal)) {
            if (isDiscontinuousRange && (isSingleCol || isSingleRow)) {
                if (isNumberBool) {
                    isStringSeries = false;
                }
                else {
                    isStringSeries = true;
                }
            }
            else {
                isStringSeries = true;
            }
        }
        if ((isNullOrUndefined(tlVal) || (opt.type === 'Scatter' && !opt.isSeriesInRows)) && !isSingleRow && !isSingleCol) {
            var startMinRow = skipHiddenIdx(sheet, minr + 1, true);
            var startMinCol = skipHiddenIdx(sheet, minc + 1, true, 'columns');
            xRange = [startMinRow, minc, maxr, minc];
            yRange = [startMinRow, startMinCol, maxr, maxc];
            lRange = [minr, startMinCol, minr, maxc];
        }
        else if (!isNullOrUndefined(blVal) && isStringSeries && !isSingleRow && !isSingleCol && !isDateTimeFormat) {
            var startMinCol = skipHiddenIdx(sheet, minc + 1, true, 'columns');
            if (!isNullOrUndefined(trVal) && (!isNumber(trVal) || !tlVal)) {
                var startMinRow = skipHiddenIdx(sheet, minr + 1, true);
                if ((opt.type === 'Pie' || opt.type === 'Doughnut') && !isDiscontinuousRange) {
                    updatePieChartRange(startMinCol, startMinRow);
                }
                else {
                    xRange = [startMinRow, minc, maxr, minc];
                    yRange = [startMinRow, startMinCol, maxr, maxc];
                    lRange = [minr, startMinCol, minr, maxc];
                }
            }
            else {
                if ((opt.type === 'Pie' || opt.type === 'Doughnut') && !isDiscontinuousRange) {
                    updatePieChartRange(startMinCol);
                }
                else {
                    xRange = [minr, minc, maxr, minc];
                    yRange = [minr, startMinCol, maxr, maxc];
                }
            }
        }
        else {
            yRange = [minr, minc, maxr, maxc];
            if ((!isNullOrUndefined(trVal) && !isNumber(trVal) && !isDateTimeFormat)) {
                if (!isSingleRow && (hasLabel || !isDiscontinuousRange)) {
                    lRange = [minr, minc, minr, maxc];
                    yRange[0] = skipHiddenIdx(sheet, yRange[0] + 1, true);
                }
            }
            else if ((isSingleRow || isSingleCol) && isNullOrUndefined(tlVal)) {
                lRange = [minr, minc, minr, maxc];
                if (isSingleRow) {
                    yRange[1] = skipHiddenIdx(sheet, yRange[1] + 1, true, 'columns');
                    lRange[3] = lRange[1];
                }
                else {
                    yRange[0] = skipHiddenIdx(sheet, yRange[0] + 1, true);
                }
            }
        }
        return { xRange: xRange, yRange: yRange, lRange: lRange, isStringSeries: isStringSeries, isDateTime: isDateTime,
            isSingleRow: isSingleRow, isSingleCol: isSingleCol, isCellFormat: isCellFormat };
    };
    SpreadsheetChart.prototype.getRangeData = function (options) {
        var sheet = options.sheet;
        if (!options.range) {
            options.range = getRangeIndexes(sheet.selectedRange);
        }
        else if (typeof (options.range) === 'string') {
            options.range = getRangeIndexes(options.range);
        }
        var rangeData = [];
        var cIdx;
        var formatArgs;
        var rIdx = options.range[0];
        var autoDetectFormatFn = options.isYvalue && getAutoDetectFormatParser(this.parent);
        while (rIdx <= options.range[2]) {
            if (isHiddenRow(sheet, rIdx)) {
                rIdx++;
                continue;
            }
            cIdx = options.range[1];
            while (cIdx <= options.range[3]) {
                if (isHiddenCol(sheet, cIdx)) {
                    cIdx++;
                    continue;
                }
                var cell = getCell(rIdx, cIdx, sheet, false, true);
                if (cell.formula && isNullOrUndefined(cell.value)) {
                    this.parent.notify(calculateFormula, { cell: cell, rowIdx: rIdx, colIdx: cIdx, sheetIndex: options.sheetIdx });
                }
                if (options.isYvalue) {
                    autoDetectFormatFn(cell);
                }
                var rObj = { value: cell.value || (cell.value === 0 ? 0 : null) };
                if (cell.format) {
                    formatArgs = {
                        formattedText: cell.value, value: cell.value, format: cell.format,
                        cell: cell, skipFormatCheck: true, checkDate: true
                    };
                    this.parent.notify(getFormattedCellObject, formatArgs);
                    if (options.isYvalue) {
                        if (isNumber(cell.value)) {
                            rObj.value = Number(cell.value);
                            rObj.displayText = formatArgs.formattedText ? formatArgs.formattedText.toString() : '';
                        }
                        else {
                            rObj.displayText = rObj.value === null ? '' : this.parent.getDisplayText({ format: cell.format, value: '0' });
                            rObj.value = 0;
                        }
                    }
                    else {
                        if (options.isScatter && !options.isDateTime && isNumber(cell.value)) {
                            rObj.value = Number(cell.value);
                        }
                        else if (options.isDateFormat && isNumber(cell.value)) {
                            rObj.value = formatArgs.dateObj ? formatArgs.dateObj : null;
                        }
                        else {
                            rObj.value = formatArgs.formattedText ? formatArgs.formattedText.toString() : null;
                        }
                    }
                }
                else if (options.isYvalue) {
                    if (isNumber(rObj.value)) {
                        rObj.displayText = rObj.value.toString();
                        rObj.value = Number(rObj.value);
                    }
                    else {
                        rObj.displayText = rObj.value === null ? '' : '0';
                        rObj.value = 0;
                    }
                }
                if (options.isSeriesNames) {
                    rObj.addr = getCellAddress(rIdx, cIdx);
                }
                rangeData.push(rObj);
                cIdx++;
            }
            rIdx++;
        }
        return rangeData;
    };
    SpreadsheetChart.prototype.toArrayData = function (args, addrColl) {
        var prop = 'value';
        var obj;
        var i = 0;
        var temp = [];
        while (i < args.length) {
            obj = args[i];
            if (Object.keys(obj).length) {
                if (prop in obj) {
                    temp.push(obj["" + prop]);
                }
            }
            else {
                temp.push('');
            }
            if (addrColl) {
                addrColl.push(obj.addr);
            }
            i++;
        }
        return temp;
    };
    SpreadsheetChart.prototype.getVirtualXValues = function (limit) {
        var i = 1;
        var arr = [];
        while (i < limit) {
            arr.push(i.toString());
            i++;
        }
        return arr;
    };
    SpreadsheetChart.prototype.isDateFormattedRange = function (range, sheet) {
        for (var col = range[1]; col <= range[3]; col++) {
            if (isHiddenCol(sheet, col)) {
                continue;
            }
            for (var row = range[0]; row <= range[2]; row++) {
                if (isHiddenRow(sheet, row)) {
                    continue;
                }
                var cell = getCell(row, col, sheet);
                if (!cell || !cell.format || (cell.value && !isNumber(cell.value)) || !isCustomDateTime(cell.format, false)) {
                    return false;
                }
            }
        }
        return true;
    };
    SpreadsheetChart.prototype.processChartSeries = function (options, sheetIndex, xRange, yRange, lRange, isDateTime, isDiscontinuousRange, seriesNumber, skipDateSeries) {
        options = options || {};
        var seriesName;
        var xValue;
        var lValue;
        var diff;
        var pArr;
        var pObj = {};
        var j;
        var i = 0;
        var yInc = 0;
        var sArr = [];
        var isDateFormat;
        var minDate;
        var maxDate;
        sheetIndex = isNullOrUndefined(sheetIndex) ? this.parent.activeSheetIndex : sheetIndex;
        var sheet = getSheet(this.parent, sheetIndex);
        var isScatter = options && options.type === 'Scatter';
        var isAccChart = options && (options.type === 'Pie' || options.type === 'Doughnut');
        var dataLabel = { name: 'displayText' };
        var isPrint = this.parent.isPrintingProcessing;
        var rDiff = ((yRange[2] - yRange[0]) + 1) - this.parent.hiddenCount(yRange[0], yRange[2], 'rows', sheet);
        var cDiff = ((yRange[3] - yRange[1]) + 1) - this.parent.hiddenCount(yRange[1], yRange[3], 'columns', sheet);
        var yValue = this.getRangeData({ range: yRange, sheet: sheet, isYvalue: true, sheetIdx: sheetIndex });
        var seriesRange;
        if (options.isSeriesInRows) {
            xValue = lRange ? this.toArrayData(this.getRangeData({ range: lRange, sheet: sheet, isScatter: isScatter,
                isDateTime: isDateTime })) : this.getVirtualXValues(cDiff + 1);
            if (isAccChart && lRange && !isDiscontinuousRange) {
                xValue = xValue.filter(function (value) { return value !== null; });
            }
            seriesRange = xRange;
            diff = rDiff;
        }
        else {
            if (xRange) {
                isDateFormat = !options.skipDateInterpolation && !skipDateSeries &&
                    !isAccChart && this.isDateFormattedRange(xRange, sheet);
                xValue = this.toArrayData(this.getRangeData({ range: xRange, sheet: sheet, isScatter: isScatter,
                    isDateTime: isDateTime, isDateFormat: isDateFormat }));
                if (isAccChart && !isDiscontinuousRange) {
                    this.generteXValueForPieChart(xRange, xValue);
                }
                if (isDateFormat) {
                    minDate = new Date(8640000000000000);
                    maxDate = new Date(-8640000000000000);
                }
            }
            else {
                xValue = this.getVirtualXValues(rDiff + 1);
            }
            seriesRange = lRange;
            diff = cDiff;
        }
        var nameAddressColl;
        var nameAddress;
        if (seriesRange) {
            nameAddressColl = isDiscontinuousRange && [];
            lValue = this.toArrayData(this.getRangeData({ range: seriesRange, sheet: sheet, isSeriesNames: true }), nameAddressColl);
        }
        var len = xValue.length;
        var inc = options.isSeriesInRows ? 1 : diff;
        if (!isNullOrUndefined(options.dataLabelSettings)) {
            dataLabel.visible = options.dataLabelSettings.visible;
            dataLabel.position = options.dataLabelSettings.position;
        }
        while (i < diff) {
            j = 0;
            pArr = [];
            yInc = options.isSeriesInRows ? yInc : i;
            while (j < len) {
                if (isDateFormat) {
                    if (isNullOrUndefined(xValue[j])) {
                        yInc += inc;
                        j++;
                        continue;
                    }
                    else {
                        var dateValue = xValue[j];
                        if (dateValue < minDate) {
                            minDate = dateValue;
                        }
                        if (dateValue > maxDate) {
                            maxDate = dateValue;
                        }
                    }
                }
                if (isNullOrUndefined(xValue[j])) {
                    xValue[j] = getUniqueID('spread-chart-empty-label-');
                }
                pArr.push({ x: xValue[j], y: yValue[yInc].value, displayText: yValue[yInc].displayText });
                yInc += inc;
                j++;
            }
            if (lValue && lValue.length > 0) {
                seriesName = lValue[i];
            }
            else if (!isDiscontinuousRange) {
                seriesName = options.type === 'Scatter' ? ('series' + (i + 1)) : ('series' + i);
            }
            seriesName = isNullOrUndefined(seriesName) ? '' : seriesName.toString();
            nameAddress = nameAddressColl ? nameAddressColl[i] : undefined;
            if (options.type) {
                var type = options.type;
                if (type === 'Line' || type === 'StackingLine' || type === 'StackingLine100') {
                    pObj = {
                        dataSource: pArr, type: options.type, xName: 'x', yName: 'y', name: seriesName, nameAddress: nameAddress,
                        animation: { enable: !isPrint }, tooltipMappingName: 'displayText',
                        marker: options.markerSettings ? { visible: options.markerSettings.visible, width: options.markerSettings.size,
                            height: options.markerSettings.size, shape: options.markerSettings.shape, dataLabel: dataLabel,
                            isFilled: options.markerSettings.isFilled, border: options.markerSettings.border,
                            fill: options.markerSettings.isFilled ? options.markerSettings.fill : null } : { dataLabel: dataLabel }
                    };
                }
                else if (type === 'Scatter') {
                    pObj = {
                        dataSource: pArr, type: options.type, xName: 'x', yName: 'y', name: seriesName, nameAddress: nameAddress,
                        tooltipMappingName: 'displayText', animation: { enable: !isPrint },
                        marker: { visible: false, width: 12, height: 12, shape: 'Circle', dataLabel: dataLabel }
                    };
                }
                else if (type === 'Pie' || type === 'Doughnut') {
                    pObj = {
                        dataSource: pArr, radius: '100%', xName: 'x', yName: 'y', innerRadius: options.type === 'Pie' ? '0%' : '40%',
                        dataLabel: { visible: !!dataLabel.visible, position: dataLabel.position === 'Outer' ? 'Outside' : 'Inside',
                            name: 'displayText', font: { fontWeight: '600' } },
                        animation: { enable: !isPrint }, tooltipMappingName: 'displayText'
                    };
                }
                else {
                    pObj = {
                        dataSource: pArr, type: options.type, xName: 'x', yName: 'y', animation: { enable: !isPrint },
                        name: seriesName, nameAddress: nameAddress, marker: { dataLabel: dataLabel }, tooltipMappingName: 'displayText'
                    };
                }
            }
            sArr.push(pObj);
            i++;
        }
        if (minDate && maxDate && minDate === maxDate) {
            return this.processChartSeries(options, sheetIndex, xRange, yRange, lRange, isDateTime, isDiscontinuousRange, seriesNumber, true);
        }
        var result;
        if (options.type) {
            result = {
                series: sArr, xRange: options.isSeriesInRows ? lRange : xRange, yRange: yRange,
                lRange: options.isSeriesInRows ? xRange : lRange, isDateFormat: isDateFormat,
                isDiscontinuousRange: isDiscontinuousRange, seriesNumber: seriesNumber, minDate: minDate, maxDate: maxDate
            };
        }
        return result;
    };
    SpreadsheetChart.prototype.generteXValueForPieChart = function (xRange, xValue) {
        if (xRange[1] !== xRange[3]) {
            var i = 0;
            var diff = (xRange[3] - xRange[1]) - this.parent.hiddenCount(xRange[1], xRange[3], 'columns') + 1;
            while (i < xValue.length) {
                xValue[i] = xValue.slice(i, i + diff).join(' ');
                xValue.splice(i + 1, Math.min(diff - 1, xValue.length - i - 1));
                i++;
            }
        }
    };
    SpreadsheetChart.prototype.getAxisFormat = function (range, sheet) {
        var format = '';
        if (!isNullOrUndefined(range)) {
            var cell = getCell(range[0], range[1], sheet);
            if (cell && cell.format) {
                format = cell.format;
            }
        }
        return format;
    };
    SpreadsheetChart.prototype.focusChartRange = function (xRange, yRange, lRange, isDiscontinuous) {
        var border = ['e-rcborderright', 'e-rcborderbottom', 'e-vcborderright', 'e-vcborderbottom', 'e-bcborderright', 'e-bcborderbottom'];
        if (!isDiscontinuous) {
            this.clearBorder();
        }
        var range;
        var sheet = this.parent.getActiveSheet();
        var isFreezePane = !!(sheet.frozenRows || sheet.frozenColumns);
        if (isFreezePane && isDiscontinuous) {
            if (lRange) {
                this.parent.notify(focusBorder, {
                    startcell: { rowIndex: lRange[0], colIndex: lRange[1] },
                    endcell: { rowIndex: yRange[2], colIndex: yRange[3] }, classes: [border[4], border[5]], isMultiRange: true
                });
            }
            else {
                this.parent.notify(focusBorder, {
                    startcell: { rowIndex: yRange[0], colIndex: yRange[1] },
                    endcell: { rowIndex: yRange[2], colIndex: yRange[3] }, classes: [border[4], border[5]], isMultiRange: true
                });
            }
            return;
        }
        if (lRange) {
            if (isFreezePane) {
                range = lRange.slice();
            }
            else {
                this.parent.notify(focusBorder, {
                    startcell: { rowIndex: lRange[0], colIndex: lRange[1] },
                    endcell: { rowIndex: lRange[2], colIndex: lRange[3] }, classes: [border[0], border[1]]
                });
            }
        }
        if (xRange) {
            if (isFreezePane) {
                if (range) {
                    range[0] = Math.min(lRange[0], xRange[0]);
                    range[1] = Math.min(lRange[1], xRange[1]);
                    range[2] = Math.max(lRange[2], xRange[2]);
                    range[3] = Math.max(lRange[3], xRange[3]);
                }
                else {
                    range = xRange.slice();
                }
            }
            else {
                this.parent.notify(focusBorder, {
                    startcell: { rowIndex: xRange[0], colIndex: xRange[1] },
                    endcell: { rowIndex: xRange[2], colIndex: xRange[3] }, classes: [border[2], border[3]]
                });
            }
        }
        if (isFreezePane && range) {
            this.parent.notify(focusBorder, {
                startcell: { rowIndex: Math.min(range[0], yRange[0]), colIndex: Math.min(range[1], yRange[1]) },
                endcell: {
                    rowIndex: Math.max(range[2], yRange[2]), colIndex: Math.max(range[3], yRange[3])
                }, classes: [border[4], border[5]]
            });
        }
        else {
            this.parent.notify(focusBorder, {
                startcell: { rowIndex: yRange[0], colIndex: yRange[1] },
                endcell: { rowIndex: yRange[2], colIndex: yRange[3] }, classes: [border[4], border[5]]
            });
        }
    };
    SpreadsheetChart.prototype.clearBorder = function () {
        var sheet = this.parent.getActiveSheet();
        if (sheet.frozenColumns || sheet.frozenRows) {
            var chartIndicator = [].slice.call(this.parent.element.getElementsByClassName('e-chart-range'));
            chartIndicator.forEach(function (indicator) { detach(indicator); });
            return;
        }
        var mainCont = this.parent.getMainContent();
        var border = ['e-rcborderright', 'e-rcborderbottom', 'e-vcborderright', 'e-vcborderbottom', 'e-bcborderright', 'e-bcborderbottom'];
        for (var borderIdx = 0, borderLen = border.length; borderIdx < borderLen; borderIdx++) {
            var eleColl = mainCont.querySelectorAll('.' + border[borderIdx]);
            for (var tdIdx = 0, eleCollLen = eleColl.length; tdIdx < eleCollLen; tdIdx++) {
                var td = eleColl[tdIdx];
                td.classList.remove(border[borderIdx]);
            }
        }
    };
    SpreadsheetChart.prototype.initiateChartHandler = function (argsOpt) {
        var _this = this;
        var isRangeSelect = isNullOrUndefined(argsOpt.isInitCell) ? true : !argsOpt.isInitCell;
        argsOpt.triggerEvent = isNullOrUndefined(argsOpt.triggerEvent) ? true : argsOpt.triggerEvent;
        argsOpt.isRefresh = isNullOrUndefined(argsOpt.isRefresh) ? false : argsOpt.isRefresh;
        var activeSheetIdx = this.parent.activeSheetIndex;
        var chart = argsOpt.option;
        var sheetIdx = (chart.range && chart.range.lastIndexOf('!') > 0) ?
            getSheetIndex(this.parent, chart.range.substring(0, chart.range.lastIndexOf('!'))) : activeSheetIdx;
        var sheet = getSheet(this.parent, sheetIdx);
        var range = chart.range ? chart.range : this.parent.getActiveSheet().selectedRange;
        var splittedRange = getRangeFromAddress(range).split(/\s+/);
        var normalizeRange = function (rangeIndexes) {
            return [
                Math.min(rangeIndexes[0], rangeIndexes[2]),
                Math.min(rangeIndexes[1], rangeIndexes[3]),
                Math.max(rangeIndexes[0], rangeIndexes[2]),
                Math.max(rangeIndexes[1], rangeIndexes[3])
            ];
        };
        var isDiscontinuousRange = splittedRange.length > 1;
        var rangeIdx = normalizeRange(getRangeIndexes(isDiscontinuousRange ? splittedRange[0] : range));
        var options = {};
        var isRowLesser;
        var seriesModel;
        var eventArgs;
        var overlayEleRange = !isNullOrUndefined(argsOpt.isInitCell) && argsOpt.isInitCell ? argsOpt.range : range;
        var overlaySIdx = argsOpt.isChangeChartType || !overlayEleRange ? activeSheetIdx :
            getSheetIndexFromAddress(this.parent, overlayEleRange);
        var isPrint = this.parent.isPrintingProcessing;
        if ((!this.parent.allowChart && sheet.isProtected) || (overlaySIdx !== activeSheetIdx && !isPrint)) {
            return seriesModel;
        }
        var args = {
            sheetIndex: sheetIdx, reqType: 'shape', type: 'actionBegin', shapeType: 'chart',
            action: 'create', options: chart, range: range, operation: 'create'
        };
        options = args.options;
        range = args.range;
        options = options || {};
        if (rangeIdx.length > 0 && !argsOpt.isRefresh && isRangeSelect) {
            var rDiff = rangeIdx[2] - rangeIdx[0];
            var cDiff = rangeIdx[3] - rangeIdx[1];
            if (rDiff < cDiff) {
                isRowLesser = true;
            }
        }
        options.isSeriesInRows = isRowLesser ? true : options.isSeriesInRows ? options.isSeriesInRows : false;
        argsOpt.dataSheetIdx = isNullOrUndefined(argsOpt.dataSheetIdx) ? sheetIdx : argsOpt.dataSheetIdx;
        var chartRange;
        var chartOptions;
        var overallChartRanges = [];
        var combinedSeries = [];
        var xAxisCaptured = false;
        var isDateFormat = false;
        var stringXRange = null;
        var minDate;
        var maxDate;
        //Function to call eventArgs for both continuous and discontinuous
        var eventTriggerArgs = function (argsOpt) {
            if (argsOpt.triggerEvent && !argsOpt.isRefresh) {
                eventArgs = {
                    type: chart.type, theme: chart.theme, isSeriesInRows: chart.isSeriesInRows, range: chart.range,
                    markerSettings: options.markerSettings, dataLabelSettings: options.dataLabelSettings, title: options.title,
                    legendSettings: options.legendSettings, primaryXAxis: options.primaryXAxis, primaryYAxis: options.primaryYAxis,
                    id: chart.id, height: chart.height, width: chart.width, posRange: argsOpt.range, isInitCell: argsOpt.isInitCell,
                    cancel: false, top: chart.top, left: chart.left, enableCanvas: chart.enableCanvas,
                    skipDateInterpolation: chart.skipDateInterpolation
                };
                _this.parent.notify(beginAction, { eventArgs: eventArgs, action: 'beforeInsertChart' });
                if (eventArgs.cancel) {
                    return [];
                }
                chart.type = eventArgs.type;
                chart.theme = eventArgs.theme;
                chart.isSeriesInRows = eventArgs.isSeriesInRows;
                chart.markerSettings = eventArgs.markerSettings;
                chart.range = eventArgs.range;
                chart.id = eventArgs.id;
                chart.height = eventArgs.height;
                chart.width = eventArgs.width;
                if (eventArgs.enableCanvas) {
                    chart.enableCanvas = eventArgs.enableCanvas;
                }
                if (eventArgs.skipDateInterpolation) {
                    chart.skipDateInterpolation = eventArgs.skipDateInterpolation;
                }
            }
        };
        if (isDiscontinuousRange) {
            // Process each discontinuous range and individual series
            var seriesNumber_1 = 0;
            var rowColSeries_1 = 0;
            var category_1;
            var hasLabel_1;
            var colSeriesMap_1 = {};
            var seriesRangeMap_1 = {};
            var labelCol_1 = new Set();
            //checking label values for string column values
            splittedRange.forEach(function (individualRange) {
                var tempRange = getRangeIndexes(individualRange);
                var rangeIndex = normalizeRange(tempRange);
                if (labelCol_1.has(rangeIndex[1])) {
                    return;
                }
                labelCol_1.add(rangeIndex[1]);
                var cell = getCell(rangeIndex[0], rangeIndex[1], sheet);
                hasLabel_1 = !isNumber(cell.value) ? true : false;
            });
            splittedRange.forEach(function (individualRange) {
                var tempRange = getRangeIndexes(individualRange);
                var rangeIndex = normalizeRange(tempRange);
                chartRange = _this.processChartRange(rangeIndex, argsOpt.dataSheetIdx, options, true, hasLabel_1);
                overallChartRanges.push(chartRange);
            });
            eventTriggerArgs(argsOpt);
            combinedSeries = [];
            var iterationNumber_1 = 0;
            this.clearBorder();
            overallChartRanges.forEach(function (chartRange) {
                if (chartRange.isStringSeries || chartRange.isDateTime &&
                    (!argsOpt.option.isSeriesInRows || !argsOpt.isSwitchRowColumn)) {
                    if (!xAxisCaptured) {
                        stringXRange = chartRange.yRange;
                        xAxisCaptured = true;
                    }
                }
                if (sheetIdx === activeSheetIdx && isRangeSelect) {
                    _this.focusChartRange(stringXRange, chartRange.yRange, chartRange.lRange, true);
                }
                if (options.isSeriesInRows) {
                    for (var i = 0; i < iterationNumber_1; i++) {
                        if (chartRange.yRange[1] === overallChartRanges[i].yRange[1] &&
                            chartRange !== overallChartRanges[i]) {
                            chartRange.lRange = overallChartRanges[i].lRange;
                        }
                    }
                }
                if (chartRange.isSingleCol || chartRange.isSingleRow) {
                    chartOptions = _this.processChartSeries(options, argsOpt.dataSheetIdx, stringXRange, chartRange.yRange, chartRange.lRange, chartRange.isDateTime, true, seriesNumber_1);
                    if (xAxisCaptured && ((chartRange.isStringSeries || chartRange.isDateTime) && !chartRange.isSingleRow) &&
                        !chartRange.isCellFormat) {
                        if (chartOptions.series && chartRange.yRange) {
                            var rangeAddress = getRangeAddress(chartRange.yRange);
                            category_1 = category_1 ? category_1 + ' ' + rangeAddress : rangeAddress;
                        }
                        delete chartOptions.series;
                        xAxisCaptured = false;
                    }
                }
                else {
                    chartOptions = _this.processChartSeries(options, argsOpt.dataSheetIdx, chartRange.xRange, chartRange.yRange, chartRange.lRange, chartRange.isDateTime, true, seriesNumber_1);
                    if (chartRange.xRange) {
                        stringXRange = chartRange.xRange;
                        var rangeAddress = getRangeAddress(chartRange.xRange);
                        category_1 = category_1 ? category_1 + ' ' + rangeAddress : rangeAddress;
                    }
                }
                isDateFormat = chartOptions.isDateFormat;
                minDate = chartOptions.minDate;
                maxDate = chartOptions.maxDate;
                if (chartOptions.series) {
                    var generatedSeries = chartOptions.series;
                    var startIdx_1 = options.isSeriesInRows ? chartRange.yRange[0] : chartRange.yRange[1];
                    generatedSeries.forEach(function (series, idx) {
                        var key = startIdx_1 + idx;
                        if (colSeriesMap_1[key]) {
                            var existingData = colSeriesMap_1[key].dataSource;
                            var newData = series.dataSource || [];
                            var existingCount = existingData ? existingData.length : 0;
                            var sampleExistingX = existingData && existingData.length ? existingData[0].x : undefined;
                            var sampleNewX = newData && newData.length ? newData[0].x : undefined;
                            var isExistingNumeric = isNumber(sampleExistingX);
                            var isNewNumeric = isNumber(sampleNewX);
                            if (isExistingNumeric && isNewNumeric) {
                                for (var i = 0; i < newData.length; i++) {
                                    var pointData = newData[i];
                                    var updatedXValue = existingCount + i + 1;
                                    pointData.x = (isExistingNumeric || isNewNumeric) ? updatedXValue : updatedXValue.toString();
                                }
                            }
                            if (existingData) {
                                existingData.push.apply(existingData, newData);
                            }
                            if (!seriesRangeMap_1[key]) {
                                seriesRangeMap_1[key] = [];
                            }
                            seriesRangeMap_1[key].push(getRangeAddress(chartRange.yRange));
                        }
                        else {
                            colSeriesMap_1[key] = series;
                            combinedSeries.push(series);
                            seriesRangeMap_1[key] = [getRangeAddress(chartRange.yRange)];
                            if (!chartRange.lRange && !argsOpt.isSwitchRowColumn) {
                                series.name = "Series" + seriesNumber_1;
                                seriesNumber_1 = seriesNumber_1 + 1;
                            }
                            else if (!chartRange.xRange && !chartOptions.lRange && (argsOpt.isSwitchRowColumn || argsOpt.isInitCell)) {
                                series.name = "Series" + rowColSeries_1;
                                rowColSeries_1++;
                            }
                        }
                    });
                }
                iterationNumber_1++;
            });
            chart.series = [];
            Object.keys(seriesRangeMap_1).forEach(function (key, index) {
                var field = parseInt(key, 10);
                var series = { range: seriesRangeMap_1[field].join(' ') };
                var seriesData = colSeriesMap_1[field];
                if (seriesData.nameAddress) {
                    series.name = "=" + seriesData.nameAddress;
                }
                if (!index && category_1) {
                    series.category = category_1;
                }
                chart.series.push(series);
            });
        }
        else {
            // Process single continuous range
            chartRange = this.processChartRange(rangeIdx, argsOpt.dataSheetIdx, options);
            if (sheetIdx === activeSheetIdx && isRangeSelect) {
                this.focusChartRange(chartRange.xRange, chartRange.yRange, chartRange.lRange);
            }
            eventTriggerArgs(argsOpt);
            chartOptions = this.processChartSeries(options, argsOpt.dataSheetIdx, chartRange.xRange, chartRange.yRange, chartRange.lRange, chartRange.isDateTime, false);
            combinedSeries = chartOptions.series;
            isDateFormat = chartOptions.isDateFormat;
            minDate = chartOptions.minDate;
            maxDate = chartOptions.maxDate;
        }
        var primaryXAxis = {
            majorGridLines: chart.primaryXAxis && chart.primaryXAxis.majorGridLines &&
                !isNullOrUndefined(chart.primaryXAxis.majorGridLines.width) ?
                { width: chart.primaryXAxis.majorGridLines.width } : { width: 0 },
            minorGridLines: chart.primaryXAxis && chart.primaryXAxis.minorGridLines &&
                !isNullOrUndefined(chart.primaryXAxis.minorGridLines.width) ?
                { width: chart.primaryXAxis.minorGridLines.width } : { width: 0 },
            majorTickLines: chart.primaryXAxis && chart.primaryXAxis.majorTickLines &&
                !isNullOrUndefined(chart.primaryXAxis.majorTickLines.width) ?
                { width: chart.primaryXAxis.majorTickLines.width } : { width: 1 },
            minorTicksPerInterval: chart.primaryXAxis && chart.primaryXAxis.minorGridLines &&
                chart.primaryXAxis.minorGridLines.width > 0 ? 5 : 0,
            labelStyle: chart.primaryXAxis && chart.primaryXAxis.labelStyle &&
                !isNullOrUndefined(chart.primaryXAxis.labelStyle.size) ?
                { size: chart.primaryXAxis.labelStyle.size } : {},
            edgeLabelPlacement: 'Shift', lineStyle: { width: 0 }, crossesAt: 0,
            rangePadding: chart.type === 'Scatter' && !chartRange.isStringSeries && !chart.isSeriesInRows ? 'Round' : 'Auto',
            title: chart.primaryXAxis ? chart.primaryXAxis.title : ''
        };
        this.isDateFormatRange = isDateFormat;
        if (this.isDateFormatRange && minDate && maxDate) {
            this.minDate = minDate;
            this.maxDate = maxDate;
            primaryXAxis.valueType = 'DateTime';
            primaryXAxis.minimum = this.minDate;
            primaryXAxis.maximum = this.maxDate;
        }
        else {
            primaryXAxis.valueType = chart.type === 'Scatter' &&
                !chartRange.isStringSeries && !chart.isSeriesInRows ? 'Double' : 'Category';
        }
        if (chart.primaryXAxis && chart.primaryXAxis.visible === false) {
            delete chart.primaryXAxis.visible;
            chart.primaryXAxis.majorTickLines = { width: 0 };
            primaryXAxis.majorTickLines = { width: 0 };
            chart.primaryXAxis.labelStyle = { size: '0px' };
            primaryXAxis.labelStyle = { size: '0px' };
        }
        var primaryYAxis = {
            majorGridLines: chart.primaryYAxis && chart.primaryYAxis.majorGridLines &&
                !isNullOrUndefined(chart.primaryYAxis.majorGridLines.width) ?
                { width: chart.primaryYAxis.majorGridLines.width } : { width: 1 },
            minorGridLines: chart.primaryYAxis && chart.primaryYAxis.minorGridLines &&
                !isNullOrUndefined(chart.primaryYAxis.minorGridLines.width) ?
                { width: chart.primaryYAxis.minorGridLines.width } : { width: 0 },
            majorTickLines: chart.primaryYAxis && chart.primaryYAxis.majorTickLines &&
                !isNullOrUndefined(chart.primaryYAxis.majorTickLines.width) ?
                { width: chart.primaryYAxis.majorTickLines.width } : { width: 1 },
            minorTicksPerInterval: chart.primaryYAxis && chart.primaryYAxis.minorGridLines &&
                chart.primaryYAxis.minorGridLines.width > 0 ? 5 : 0,
            labelStyle: chart.primaryYAxis && chart.primaryYAxis.labelStyle &&
                !isNullOrUndefined(chart.primaryYAxis.labelStyle.size) ?
                { size: chart.primaryYAxis.labelStyle.size } : {},
            edgeLabelPlacement: 'Shift', lineStyle: { width: 0 },
            crossesAt: this.isDateFormatRange ? null : 0,
            title: chart.primaryYAxis ? chart.primaryYAxis.title : ''
        };
        if (chart.primaryYAxis && chart.primaryYAxis.visible === false) {
            delete chart.primaryYAxis.visible;
            chart.primaryYAxis.majorTickLines = { width: 0 };
            primaryYAxis.majorTickLines = { width: 0 };
            chart.primaryYAxis.labelStyle = { size: '0px' };
            primaryYAxis.labelStyle = { size: '0px' };
        }
        this.primaryYAxisFormat = this.getAxisFormat(chartRange.yRange, sheet);
        this.primaryXAxisFormat = isDiscontinuousRange ? this.getAxisFormat(stringXRange, sheet) :
            this.getAxisFormat(chartRange.xRange, sheet);
        if (argsOpt.isRefresh) {
            var chartObj = this.parent.element.querySelector('.' + chart.id);
            var chartComp = void 0;
            if (chartObj) {
                chartComp = getComponent(chartObj, 'chart');
                var isScatterSwitch = argsOpt.isSwitchRowColumn && chart.type === 'Scatter';
                var isNonAccChart = chart.type !== 'Pie' && chart.type !== 'Doughnut';
                if (isScatterSwitch || isNonAccChart) {
                    if (this.isDateFormatRange) {
                        chartComp.primaryXAxis.valueType = 'DateTime';
                        chartComp.primaryXAxis.minimum = this.minDate;
                        chartComp.primaryXAxis.maximum = this.maxDate;
                    }
                    else {
                        chartComp.primaryXAxis.valueType = isScatterSwitch && !chartRange.isStringSeries
                            && !chart.isSeriesInRows ? 'Double' : 'Category';
                        if (chartComp.primaryXAxis.minimum) {
                            chartComp.primaryXAxis.minimum = null;
                        }
                        if (chartComp.primaryXAxis.maximum) {
                            chartComp.primaryXAxis.maximum = null;
                        }
                    }
                }
            }
            return combinedSeries;
        }
        var id = chart.id + '_overlay';
        var overlayObj = this.parent.serviceLocator.getService(overlay);
        var overlayProps = overlayObj.insertOverlayElement(id, overlayEleRange, overlaySIdx);
        overlayProps.element.classList.add('e-datavisualization-chart');
        overlayProps.element.style.width = chart.width + 'px';
        overlayProps.element.style.height = chart.height + 'px';
        if (sheet && (sheet.frozenRows || sheet.frozenColumns)) {
            overlayObj.adjustFreezePaneSize(chart, overlayProps.element, overlayEleRange);
        }
        else {
            if (isNullOrUndefined(chart.top)) {
                chart.top = overlayProps.top;
            }
            else {
                overlayProps.element.style.top = Number(addDPRValue(chart.top).toFixed(2)) + 'px';
            }
            if (isNullOrUndefined(chart.left)) {
                chart.left = overlayProps.left;
            }
            else {
                overlayProps.element.style.left = Number(addDPRValue(chart.left).toFixed(2)) + 'px';
            }
        }
        this.parent.notify(overlayEleSize, { height: chart.height, width: chart.width });
        var legendSettings = (chart.type === 'Pie' || chart.type === 'Doughnut') ? { position: 'Bottom', visible: true } : {};
        if (!isNullOrUndefined(chart.legendSettings)) {
            legendSettings.visible = chart.legendSettings.visible;
            legendSettings.position = chart.legendSettings.position;
        }
        var theme = chart.theme || 'Material';
        var borderWidth = Math.round(parseFloat(getComputedStyle(overlayProps.element).borderWidth)) * 2;
        var height = (parseFloat(overlayProps.element.style.height) - (isNaN(borderWidth) ? 0 : borderWidth)) + 'px';
        var chartContent = this.parent.createElement('div', { id: chart.id, className: chart.id });
        if (chart.type !== 'Pie' && chart.type !== 'Doughnut') {
            this.chart = new Chart({
                primaryXAxis: primaryXAxis,
                primaryYAxis: primaryYAxis,
                background: this.getThemeBgColor(theme),
                chartArea: { border: { width: 0 } },
                title: chart.title,
                legendSettings: legendSettings,
                theme: theme,
                series: combinedSeries,
                tooltip: { enable: true, format: '${point.x} : <b>${point.tooltip}</b>' },
                width: overlayProps.element.style.width,
                height: height,
                enableRtl: this.parent.enableRtl,
                enableCanvas: chart.enableCanvas ? true : false,
                load: function (args) {
                    args.chart.theme = chart.theme || 'Material';
                },
                beforeResize: function (args) {
                    args.cancelResizedEvent = true; // This is for cancel the resized event.
                },
                tooltipRender: function (args) {
                    if (_this.isDateFormatRange) {
                        if (_this.primaryXAxisFormat) {
                            var point = args.point;
                            var val = dateToInt(new Date(point.xValue));
                            var xValue = _this.parent.getDisplayText({ format: _this.primaryXAxisFormat, value: val.toString() });
                            args.text = xValue + " : <b>" + point.yValue + "</b>";
                        }
                    }
                    else if (chartRange.isDateTime) {
                        var isXNegative = args.point.x && _this.isDateTimeNegativeValue(args.point.x.toString());
                        var isTooltipNegative = args.point.tooltip &&
                            _this.isDateTimeNegativeValue(args.point.tooltip.toString());
                        if (isXNegative || isTooltipNegative) {
                            var point = args.point;
                            var xValue = isXNegative ? point.xValue : args.point.x;
                            var yValue = isTooltipNegative ? point.yValue : args.point.tooltip;
                            args.text = xValue + " : <b>" + yValue + "</b>";
                        }
                    }
                },
                axisLabelRender: function (args) {
                    if (args.axis.name === 'primaryYAxis' && _this.primaryYAxisFormat && !chart.type.includes('100') &&
                        !isNullOrUndefined(args.value) && _this.parent) {
                        args.text = _this.parent.getDisplayText({ format: _this.primaryYAxisFormat, value: args.value.toString() });
                    }
                    else if (args.axis.name === 'primaryXAxis' && args.text.startsWith('spread-chart-empty-label-')) {
                        args.text = '';
                    }
                    if (args.axis.name === 'primaryXAxis') {
                        if (chart.type === 'Scatter' && !chartRange.isDateTime) {
                            if (args.axis.labels.length > 0 && !isNumber(args.text)) {
                                args.text = (args.axis.labels.indexOf(args.text) + 1).toString();
                            }
                            else if (_this.primaryXAxisFormat && !isNullOrUndefined(args.value)) {
                                args.text = _this.parent.getDisplayText({ format: _this.primaryXAxisFormat, value: args.value.toString() });
                            }
                        }
                        else if (_this.isDateFormatRange && _this.primaryXAxisFormat) {
                            var val = dateToInt(new Date(args.value));
                            args.text = _this.parent.getDisplayText({ format: _this.primaryXAxisFormat, value: val.toString() });
                        }
                    }
                    if (chartRange.isDateTime && args.text && _this.isDateTimeNegativeValue(args.text)) {
                        args.cancel = true;
                    }
                },
                seriesRender: function (args) {
                    if (_this.isDateFormatRange && (chart.type.includes('Area') || chart.type.includes('Line'))) {
                        args.data.sort(function (fVal, sVal) { return fVal.x.getTime() - sVal.x.getTime(); });
                    }
                }
            });
            this.chart.appendTo(chartContent);
        }
        else {
            this.chart = new AccumulationChart({
                title: chart.title,
                legendSettings: legendSettings,
                theme: theme,
                background: this.getThemeBgColor(theme),
                series: combinedSeries,
                width: overlayProps.element.style.width,
                height: height,
                center: { x: '50%', y: '50%' },
                tooltip: { enable: true, format: '${point.x} : <b>${point.tooltip}</b>' },
                enableSmartLabels: true,
                enableAnimation: true,
                enableRtl: this.parent.enableRtl,
                load: function (args) {
                    args.chart.theme = chart.theme || 'Material';
                },
                beforeResize: function (args) {
                    args.cancelResizedEvent = true; // This is for cancel the resized event.
                }
            });
            this.chart.appendTo(chartContent);
        }
        overlayProps.element.appendChild(chartContent);
        if (overlayProps.element.classList.contains('e-ss-overlay-active') && !isPrint) {
            this.parent.notify(insertDesignChart, { id: overlayProps.element.id });
        }
        if (argsOpt.triggerEvent) {
            this.parent.notify(completeAction, { eventArgs: eventArgs, action: 'insertChart' });
        }
        return seriesModel;
    };
    SpreadsheetChart.prototype.isDateTimeNegativeValue = function (value) {
        return value.startsWith('###') && !value.split('#').join('');
    };
    SpreadsheetChart.prototype.deleteChart = function (args) {
        this.clearBorder();
        var chartElements = null;
        var sheet = this.parent.getActiveSheet();
        if (isNullOrUndefined(args.id)) {
            chartElements = document.querySelector('.e-datavisualization-chart.e-ss-overlay-active');
            args.id = chartElements ? chartElements.getElementsByClassName('e-control')[0].id : null;
        }
        else {
            args.id = args.id.includes('overlay') ? args.id : args.id + '_overlay';
            chartElements = document.getElementById(args.id);
        }
        if (isNullOrUndefined(args.id)) {
            return;
        }
        else {
            args.id = args.id.includes('overlay') ? args.id : args.id + '_overlay';
        }
        var rowIdx;
        var colIdx;
        var prevCellChart;
        var isRemoveEle = false;
        var chartObj;
        for (var i = 0, chartCollLen = this.parent.chartColl.length; i < chartCollLen; i++) {
            if (this.parent.chartColl[i].id === args.id.split('_overlay')[0]) {
                chartObj = this.parent.chartColl[i];
                break;
            }
        }
        var eventArgs = {
            id: chartObj.id, range: chartObj.range, type: chartObj.type, markerSettings: chartObj.markerSettings,
            dataLabelSettings: chartObj.dataLabelSettings, title: chartObj.title, legendSettings: chartObj.legendSettings,
            primaryXAxis: chartObj.primaryXAxis, primaryYAxis: chartObj.primaryYAxis, theme: chartObj.theme,
            height: chartObj.height, width: chartObj.width, isSeriesInRows: chartObj.isSeriesInRows,
            isInitCell: true, posRange: null, top: chartObj.top, left: chartObj.left, cancel: false,
            enableCanvas: chartObj.enableCanvas, skipDateInterpolation: chartObj.skipDateInterpolation
        };
        if (chartElements) {
            var chartTop = void 0;
            var chartleft = void 0;
            if (sheet.frozenRows || sheet.frozenColumns) {
                if (chartObj.address) {
                    rowIdx = chartObj.address[0];
                    colIdx = chartObj.address[1];
                }
                else {
                    var clientRect = chartElements.getBoundingClientRect();
                    chartTop = { clientY: clientRect.top };
                    chartleft = { clientX: clientRect.left };
                    if (clientRect.top < this.parent.getColumnHeaderContent().getBoundingClientRect().bottom) {
                        chartTop.target = this.parent.getColumnHeaderContent();
                    }
                    if (clientRect.left < this.parent.getRowHeaderContent().getBoundingClientRect().right) {
                        chartleft.target = this.parent.getRowHeaderTable();
                    }
                    this.parent.notify(getRowIdxFromClientY, chartTop);
                    this.parent.notify(getColIdxFromClientX, chartleft);
                    rowIdx = chartTop.clientY;
                    colIdx = chartleft.clientX;
                }
            }
            else {
                chartTop = { clientY: parseFloat(chartElements.style.top), isImage: true };
                chartleft = { clientX: parseFloat(chartElements.style.left), isImage: true };
                this.parent.notify(getRowIdxFromClientY, chartTop);
                this.parent.notify(getColIdxFromClientX, chartleft);
                rowIdx = chartTop.clientY;
                colIdx = chartleft.clientX;
            }
            this.parent.notify(deleteChartColl, { id: args.id });
            isRemoveEle = true;
            sheet = this.parent.sheets[this.parent.activeSheetIndex];
        }
        else {
            this.parent.notify(deleteChartColl, { id: args.id });
            var lastIndex = args.range ? args.range.lastIndexOf('!') : 0;
            var sheetIndex = args.range && lastIndex > 0 ?
                getSheetIndex(this.parent, args.range.substring(0, lastIndex)) : this.parent.activeSheetIndex;
            var rangeVal = args.range ? lastIndex > 0 ? args.range.substring(lastIndex + 1) : args.range :
                this.parent.getActiveSheet().selectedRange;
            var index = getRangeIndexes(rangeVal);
            rowIdx = index[0];
            colIdx = index[1];
            sheet = this.parent.sheets[sheetIndex];
        }
        var cellObj = getCell(rowIdx, colIdx, sheet);
        if (cellObj) {
            prevCellChart = cellObj.chart;
        }
        var chartLength = prevCellChart ? prevCellChart.length : null;
        for (var i = 0; i < chartLength; i++) {
            if (args.id === prevCellChart[i].id + '_overlay') {
                prevCellChart.splice(i, 1);
                chartLength = prevCellChart.length;
            }
        }
        if (isRemoveEle) {
            document.getElementById(args.id).remove();
            focus(this.parent.element);
            this.parent.notify(removeDesignChart, {});
        }
        setCell(rowIdx, colIdx, sheet, { chart: prevCellChart }, true);
        eventArgs.posRange = sheet.name + '!' + getCellAddress(rowIdx, colIdx);
        if (!args.isUndoRedo) {
            this.parent.notify(completeAction, { eventArgs: eventArgs, action: 'deleteChart', isClearAction: args.clearAction });
        }
    };
    SpreadsheetChart.prototype.updateChartModel = function (eleId, chartComp, currCellObj, chartCollId, isAccumulationChart) {
        var accumulationChartComp = chartComp;
        chartComp = chartComp;
        var chartId = this.parent.chartColl[chartCollId].id;
        if (isAccumulationChart &&
            ['PHAxes', 'PVAxes', 'PHAxisTitle', 'PVAxisTitle', 'GLMajorHorizontal',
                'GLMajorVertical', 'GLMinorHorizontal', 'GLMinorVertical'].indexOf(eleId) > -1) {
            return;
        }
        if (!currCellObj || isNullOrUndefined(currCellObj.chart)) {
            return;
        }
        for (var idx = 0, chartsCount = currCellObj.chart.length; idx < chartsCount; idx++) {
            if (currCellObj.chart[idx].id === chartId) {
                switch (eleId) {
                    case 'PHAxes':
                    case 'PHAxisTitle':
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryXAxis)) {
                            currCellObj.chart[idx].primaryXAxis = {};
                            this.parent.chartColl[chartCollId].primaryXAxis = {};
                        }
                        if (eleId === 'PHAxes') {
                            if (isNullOrUndefined(currCellObj.chart[idx].primaryXAxis.majorTickLines)) {
                                currCellObj.chart[idx].primaryXAxis.majorTickLines = {};
                                this.parent.chartColl[chartCollId].primaryXAxis.majorTickLines = {};
                            }
                            currCellObj.chart[idx].primaryXAxis.majorTickLines.width =
                                chartComp.primaryXAxis.majorTickLines.width;
                            this.parent.chartColl[chartCollId].primaryXAxis.majorTickLines.width =
                                chartComp.primaryXAxis.majorTickLines.width;
                            if (isNullOrUndefined(currCellObj.chart[idx].primaryXAxis.labelStyle)) {
                                currCellObj.chart[idx].primaryXAxis.labelStyle = {};
                                this.parent.chartColl[chartCollId].primaryXAxis.labelStyle = {};
                            }
                            currCellObj.chart[idx].primaryXAxis.labelStyle.size =
                                chartComp.primaryXAxis.labelStyle.size;
                            this.parent.chartColl[chartCollId].primaryXAxis.labelStyle.size =
                                chartComp.primaryXAxis.labelStyle.size;
                        }
                        else if (eleId === 'PHAxisTitle') {
                            currCellObj.chart[idx].primaryXAxis.title = chartComp.primaryXAxis.title;
                            this.parent.chartColl[chartCollId].primaryXAxis.title = chartComp.primaryXAxis.title;
                        }
                        break;
                    case 'PVAxes':
                    case 'PVAxisTitle':
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryYAxis)) {
                            currCellObj.chart[idx].primaryYAxis = {};
                            this.parent.chartColl[chartCollId].primaryYAxis = {};
                        }
                        if (eleId === 'PVAxes') {
                            if (isNullOrUndefined(currCellObj.chart[idx].primaryYAxis.majorTickLines)) {
                                currCellObj.chart[idx].primaryYAxis.majorTickLines = {};
                                this.parent.chartColl[chartCollId].primaryYAxis.majorTickLines = {};
                            }
                            currCellObj.chart[idx].primaryYAxis.majorTickLines.width =
                                chartComp.primaryYAxis.majorTickLines.width;
                            this.parent.chartColl[chartCollId].primaryYAxis.majorTickLines.width =
                                chartComp.primaryYAxis.majorTickLines.width;
                            if (isNullOrUndefined(currCellObj.chart[idx].primaryYAxis.labelStyle)) {
                                currCellObj.chart[idx].primaryYAxis.labelStyle = {};
                                this.parent.chartColl[chartCollId].primaryYAxis.labelStyle = {};
                            }
                            currCellObj.chart[idx].primaryYAxis.labelStyle.size =
                                chartComp.primaryYAxis.labelStyle.size;
                            this.parent.chartColl[chartCollId].primaryYAxis.labelStyle.size =
                                chartComp.primaryYAxis.labelStyle.size;
                        }
                        else if (eleId === 'PVAxisTitle') {
                            currCellObj.chart[idx].primaryYAxis.title = chartComp.primaryYAxis.title;
                            this.parent.chartColl[chartCollId].primaryYAxis.title = chartComp.primaryYAxis.title;
                        }
                        break;
                    case 'ChartTitleNone':
                    case 'ChartTitleAbove':
                        currCellObj.chart[idx].title = chartComp.title;
                        this.parent.chartColl[chartCollId].title = chartComp.title;
                        break;
                    case 'DLNone':
                    case 'DLCenter':
                    case 'DLInsideend':
                    case 'DLInsidebase':
                    case 'DLOutsideend':
                        if (isNullOrUndefined(currCellObj.chart[idx].dataLabelSettings)) {
                            currCellObj.chart[idx].dataLabelSettings = {};
                            this.parent.chartColl[chartCollId].dataLabelSettings = {};
                        }
                        if (eleId === 'DLNone') {
                            currCellObj.chart[idx].dataLabelSettings.visible = false;
                            this.parent.chartColl[chartCollId].dataLabelSettings.visible = false;
                        }
                        else {
                            currCellObj.chart[idx].dataLabelSettings.visible = true;
                            this.parent.chartColl[chartCollId].dataLabelSettings.visible = true;
                            var position = void 0;
                            if (isAccumulationChart) {
                                position = accumulationChartComp.series[0].dataLabel.position === 'Outside' ? 'Outer' : 'Middle';
                            }
                            else {
                                position = chartComp.series[0].marker.dataLabel.position;
                            }
                            currCellObj.chart[idx].dataLabelSettings.position = position;
                            this.parent.chartColl[chartCollId].dataLabelSettings.position = position;
                        }
                        break;
                    case 'GLMajorHorizontal':
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryYAxis)) {
                            currCellObj.chart[idx].primaryYAxis = {};
                            this.parent.chartColl[chartCollId].primaryYAxis = {};
                        }
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryYAxis.majorGridLines)) {
                            currCellObj.chart[idx].primaryYAxis.majorGridLines = {};
                            this.parent.chartColl[chartCollId].primaryYAxis.majorGridLines = {};
                        }
                        currCellObj.chart[idx].primaryYAxis.majorGridLines.width = chartComp.primaryYAxis.majorGridLines.width;
                        this.parent.chartColl[chartCollId].primaryYAxis.majorGridLines.width =
                            chartComp.primaryYAxis.majorGridLines.width;
                        break;
                    case 'GLMajorVertical':
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryXAxis)) {
                            currCellObj.chart[idx].primaryXAxis = {};
                            this.parent.chartColl[chartCollId].primaryXAxis = {};
                        }
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryXAxis.majorGridLines)) {
                            currCellObj.chart[idx].primaryXAxis.majorGridLines = {};
                            this.parent.chartColl[chartCollId].primaryXAxis.majorGridLines = {};
                        }
                        currCellObj.chart[idx].primaryXAxis.majorGridLines.width = chartComp.primaryXAxis.majorGridLines.width;
                        this.parent.chartColl[chartCollId].primaryXAxis.majorGridLines.width =
                            chartComp.primaryXAxis.majorGridLines.width;
                        break;
                    case 'GLMinorHorizontal':
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryYAxis)) {
                            currCellObj.chart[idx].primaryYAxis = {};
                            this.parent.chartColl[chartCollId].primaryYAxis = {};
                        }
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryYAxis.minorGridLines)) {
                            currCellObj.chart[idx].primaryYAxis.minorGridLines = {};
                            this.parent.chartColl[chartCollId].primaryYAxis.minorGridLines = {};
                        }
                        currCellObj.chart[idx].primaryYAxis.minorGridLines.width = chartComp.primaryYAxis.minorGridLines.width;
                        this.parent.chartColl[chartCollId].primaryYAxis.minorGridLines.width =
                            chartComp.primaryYAxis.minorGridLines.width;
                        break;
                    case 'GLMinorVertical':
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryXAxis)) {
                            currCellObj.chart[idx].primaryXAxis = {};
                            this.parent.chartColl[chartCollId].primaryXAxis = {};
                        }
                        if (isNullOrUndefined(currCellObj.chart[idx].primaryXAxis.minorGridLines)) {
                            currCellObj.chart[idx].primaryXAxis.minorGridLines = {};
                            this.parent.chartColl[chartCollId].primaryXAxis.minorGridLines = {};
                        }
                        currCellObj.chart[idx].primaryXAxis.minorGridLines.width = chartComp.primaryXAxis.minorGridLines.width;
                        this.parent.chartColl[chartCollId].primaryXAxis.minorGridLines.width =
                            chartComp.primaryXAxis.minorGridLines.width;
                        break;
                    case 'LegendNone':
                    case 'LegendsRight':
                    case 'LegendsLeft':
                    case 'LegendsBottom':
                    case 'LegendsTop':
                        if (isNullOrUndefined(currCellObj.chart[idx].legendSettings)) {
                            currCellObj.chart[idx].legendSettings = {};
                            this.parent.chartColl[chartCollId].legendSettings = {};
                        }
                        currCellObj.chart[idx].legendSettings.visible = chartComp.legendSettings.visible;
                        this.parent.chartColl[chartCollId].legendSettings.visible = chartComp.legendSettings.visible;
                        if (eleId !== 'LegendNone') {
                            currCellObj.chart[idx].legendSettings.position = chartComp.legendSettings.position;
                            this.parent.chartColl[chartCollId].legendSettings.position =
                                chartComp.legendSettings.position;
                            break;
                        }
                }
            }
        }
    };
    SpreadsheetChart.prototype.updateChartElement = function (value, chartComp, currCellObj, chartCollId, title, pXAxisLabelSize, pYAxisLabelSize, isAccumulationChart, isBarChart, address, triggerEvent) {
        var chartSeries;
        if (isBarChart) {
            var axisMapping = new Map([
                ['PHAxes', 'PVAxes'],
                ['PVAxes', 'PHAxes'],
                ['PHAxisTitle', 'PVAxisTitle'],
                ['PVAxisTitle', 'PHAxisTitle'],
                ['GLMajorHorizontal', 'GLMajorVertical'],
                ['GLMajorVertical', 'GLMajorHorizontal'],
                ['GLMinorHorizontal', 'GLMinorVertical'],
                ['GLMinorVertical', 'GLMinorHorizontal']
            ]);
            var mappedValue = axisMapping.get(value);
            if (mappedValue) {
                value = mappedValue;
            }
        }
        switch (value) {
            case 'PHAxes':
                chartComp = chartComp;
                if (chartComp.primaryXAxis.labelStyle.size === '0px') {
                    chartComp.primaryXAxis.labelStyle.size = pXAxisLabelSize;
                    chartComp.primaryXAxis.majorTickLines.width = 1;
                }
                else {
                    chartComp.primaryXAxis.labelStyle.size = '0px';
                    chartComp.primaryXAxis.majorTickLines.width = 0;
                }
                break;
            case 'PVAxes':
                chartComp = chartComp;
                if (chartComp.primaryYAxis.labelStyle.size === '0px') {
                    chartComp.primaryYAxis.labelStyle.size = pYAxisLabelSize;
                    chartComp.primaryYAxis.majorTickLines.width = 1;
                }
                else {
                    chartComp.primaryYAxis.labelStyle.size = '0px';
                    chartComp.primaryYAxis.majorTickLines.width = 0;
                }
                break;
            case 'PHAxisTitle':
                chartComp = chartComp;
                chartComp.primaryXAxis.title = title;
                break;
            case 'PVAxisTitle':
                chartComp = chartComp;
                chartComp.primaryYAxis.title = title;
                break;
            case 'ChartTitleNone':
                chartComp.title = '';
                break;
            case 'ChartTitleAbove':
                chartComp.title = title;
                break;
            case 'DLNone':
            case 'DLCenter':
            case 'DLInsideend':
            case 'DLInsidebase':
            case 'DLOutsideend':
                chartComp = isAccumulationChart ? chartComp : chartComp;
                chartSeries = chartComp.series;
                if (value === 'DLNone') {
                    for (var idx = 0, len = chartSeries.length; idx < len; idx++) {
                        if (isAccumulationChart) {
                            chartSeries[idx].dataLabel.visible = false;
                        }
                        else {
                            chartSeries[idx].marker.dataLabel.visible = false;
                        }
                    }
                }
                else {
                    for (var idx = 0, len = chartSeries.length; idx < len; idx++) {
                        if (isAccumulationChart) {
                            var position = value === 'DLOutsideend' ? 'Outside' : 'Inside';
                            chartSeries[idx].dataLabel.visible = true;
                            chartSeries[idx].dataLabel.position = position;
                        }
                        else {
                            var position = value === 'DLCenter' ? 'Middle' : value === 'DLInsideend' ? 'Top' : value === 'DLInsidebase' ?
                                'Bottom' : value === 'DLOutsideend' ? 'Outer' : chartSeries[0].marker.dataLabel.position;
                            chartSeries[idx].marker.dataLabel.visible = true;
                            chartSeries[idx].marker.dataLabel.position = position;
                        }
                    }
                }
                chartComp.series = chartSeries;
                if (isAccumulationChart) {
                    chartComp.refresh();
                }
                break;
            case 'GLMajorHorizontal':
                chartComp = chartComp;
                chartComp.primaryYAxis.majorGridLines.width = chartComp.primaryYAxis.majorGridLines.width === 0 ? 1 : 0;
                break;
            case 'GLMajorVertical':
                chartComp = chartComp;
                chartComp.primaryXAxis.majorGridLines.width = chartComp.primaryXAxis.majorGridLines.width === 0 ? 1 : 0;
                break;
            case 'GLMinorHorizontal':
                chartComp = chartComp;
                chartComp.primaryYAxis.minorTicksPerInterval = chartComp.primaryYAxis.minorGridLines.width === 0 ? 5 : 0;
                chartComp.primaryYAxis.minorGridLines.width = chartComp.primaryYAxis.minorGridLines.width === 0 ? 1 : 0;
                break;
            case 'GLMinorVertical':
                chartComp = chartComp;
                chartComp.primaryXAxis.minorTicksPerInterval = chartComp.primaryXAxis.minorGridLines.width === 0 ? 5 : 0;
                chartComp.primaryXAxis.minorGridLines.width = chartComp.primaryXAxis.minorGridLines.width === 0 ? 1 : 0;
                break;
            case 'LegendNone':
                chartComp.legendSettings.visible = false;
                break;
            case 'LegendsRight':
            case 'LegendsLeft':
            case 'LegendsBottom':
            case 'LegendsTop':
                chartComp.legendSettings.visible = true;
                chartComp.legendSettings.position = value === 'LegendsRight' ? 'Right' : value === 'LegendsLeft' ? 'Left' : value ===
                    'LegendsBottom' ? 'Bottom' : value === 'LegendsTop' ? 'Top' : chartComp.legendSettings.position;
                break;
        }
        this.updateChartModel(value, chartComp, currCellObj, chartCollId, isAccumulationChart);
        if (triggerEvent) {
            var eventArgs = { addChartEle: value, id: chartComp.element.id + '_overlay', title: title, address: address };
            this.parent.notify(completeAction, { action: 'chartDesign', eventArgs: eventArgs });
        }
    };
    SpreadsheetChart.prototype.undoRedoForChartDesign = function (args) {
        var overlayElem = document.getElementById(args.id);
        if (!overlayElem) {
            return;
        }
        var isAccumulationChart = false;
        var chartElem = this.getChartElement(overlayElem);
        var chartComp = getComponent(chartElem, 'chart');
        if (isNullOrUndefined(chartComp)) {
            chartComp = getComponent(chartElem, 'accumulationchart');
            isAccumulationChart = true;
        }
        var addressInfo = this.parent.getAddressInfo(args.address);
        var cell = getCell(addressInfo.indices[0], addressInfo.indices[1], getSheet(this.parent, addressInfo.sheetIndex));
        if (!cell || isNullOrUndefined(cell.chart)) {
            return;
        }
        var chartCollectionId = this.getChartCollectionId(chartElem.id);
        var chart;
        var property = args.addChartEle;
        var title = args.title;
        for (var i = 0; i < args.beforeActionData.cellDetails[0].chart.length; i++) {
            if (chartElem.id === args.beforeActionData.cellDetails[0].chart[i].id) {
                chart = args.beforeActionData.cellDetails[0].chart[i];
                break;
            }
        }
        var isMarkerEnabled = isNullOrUndefined(chart.markerSettings) ? false : chart.markerSettings.visible;
        if (args.switchRowColumn) {
            this.switchRowColumn(chartCollectionId, chartElem.id, chartComp, cell);
        }
        else if (args.chartTheme) {
            this.switchChartTheme(chartCollectionId, chartElem.id, args.isUndo ? chart.theme : args.chartTheme, chartComp, cell);
        }
        else if (args.chartType) {
            this.switchChartType(chartCollectionId, chartElem.id, args.isUndo ? chart.type : args.chartType, chartComp, cell, false, args.isUndo ? isMarkerEnabled : args.chartMarker, 'undoRedo');
        }
        else if (args.addChartEle) {
            if (args.isUndo) {
                var position = void 0;
                switch (property) {
                    case 'DLNone':
                    case 'DLCenter':
                    case 'DLInsideend':
                    case 'DLInsidebase':
                    case 'DLOutsideend':
                        position = chart.dataLabelSettings && chart.dataLabelSettings.position;
                        property = position === 'Middle' ? 'DLCenter' : position === 'Top' ? 'DLInsideend' : position === 'Bottom' ?
                            'DLInsidebase' : position === 'Outer' ? 'DLOutsideend' : 'DLNone';
                        break;
                    case 'LegendNone':
                    case 'LegendsRight':
                    case 'LegendsLeft':
                    case 'LegendsBottom':
                    case 'LegendsTop':
                        if (chart.legendSettings && !chart.legendSettings.visible) {
                            position = 'LegendNone';
                        }
                        else {
                            position = chart.legendSettings && chart.legendSettings.position;
                            property = position === 'Right' ? 'LegendsRight' : position === 'Left' ? 'LegendsLeft' : position ===
                                'Bottom' ? 'LegendsBottom' : position === 'Top' ? 'LegendsTop' : 'LegendsBottom';
                        }
                        break;
                    case 'PVAxisTitle':
                        title = chart.primaryYAxis && chart.primaryYAxis.title;
                        break;
                    case 'PHAxisTitle':
                        title = chart.primaryXAxis && chart.primaryXAxis.title;
                        break;
                    case 'ChartTitleNone':
                    case 'ChartTitleAbove':
                        title = chart.title;
                        break;
                }
            }
            var isBarChart = chart.type.includes('Bar') && property !== 'PHAxisTitle' && property !== 'PVAxisTitle';
            this.updateChartElement(property, chartComp, cell, chartCollectionId, title, args.pXAxisLSize, args.pYAxisLSize, isAccumulationChart, isBarChart, args.address);
        }
    };
    SpreadsheetChart.prototype.chartDesignTabHandler = function (args) {
        var isAccumulationChart = false;
        var pXAxisLSize;
        var pYAxisLSize;
        var sheet = this.parent.sheets[this.parent.activeSheetIndex];
        var switchRowColumn = args.switchRowColumn;
        var chartType = args.chartType;
        var chartTheme = args.chartTheme;
        var addChartEle = args.addChartEle;
        var chartComp = null;
        var overlayElem = args.id ? document.getElementById(args.id) : document.querySelector('.e-datavisualization-chart.e-ss-overlay-active');
        if (!overlayElem) {
            return;
        }
        var opensTitleDialog = addChartEle === 'ChartTitleAbove' || addChartEle === 'PHAxisTitle' || addChartEle === 'PVAxisTitle';
        var chartTop;
        var chartleft;
        if (sheet.frozenRows || sheet.frozenColumns) {
            var clientRect = overlayElem.getBoundingClientRect();
            chartTop = { clientY: clientRect.top };
            chartleft = { clientX: clientRect.left };
            if (clientRect.top < this.parent.getColumnHeaderContent().getBoundingClientRect().bottom) {
                chartTop.target = this.parent.getColumnHeaderContent();
            }
            if (clientRect.left < this.parent.getRowHeaderContent().getBoundingClientRect().right) {
                chartleft.target = this.parent.getRowHeaderTable();
            }
        }
        else {
            chartTop = { clientY: overlayElem.offsetTop, isImage: true };
            chartleft = { clientX: overlayElem.offsetLeft, isImage: true };
        }
        this.parent.notify(getRowIdxFromClientY, chartTop);
        this.parent.notify(getColIdxFromClientX, chartleft);
        var currCellObj = getCell(chartTop.clientY, chartleft.clientX, sheet);
        if (!currCellObj || isNullOrUndefined(currCellObj.chart)) {
            return;
        }
        var address = sheet.name + '!' + getCellAddress(chartTop.clientY, chartleft.clientX);
        if (args.triggerEvent) {
            var eventArgs = {
                switchRowColumn: args.switchRowColumn, chartType: args.chartType, chartTheme: args.chartTheme,
                addChartEle: args.addChartEle, id: overlayElem.id, address: address, cancel: false
            };
            this.parent.notify(beginAction, { action: 'chartDesign', eventArgs: eventArgs });
            if (eventArgs.cancel) {
                return;
            }
        }
        var chartObj = this.getChartElement(overlayElem);
        var chartId = chartObj.getAttribute('id');
        var chartCollId = this.getChartCollectionId(chartId);
        if (chartObj) {
            chartComp = getComponent(chartObj, 'chart');
            if (isNullOrUndefined(chartComp)) {
                chartComp = getComponent(chartObj, 'accumulationchart');
                isAccumulationChart = true;
            }
        }
        if (!isAccumulationChart && (addChartEle === 'PVAxes' || addChartEle === 'PHAxes')) {
            chartComp = chartComp;
            if (chartComp.primaryXAxis.labelStyle.size !== '0px') {
                pXAxisLSize = chartComp.primaryXAxis.labelStyle.size;
            }
            if (chartComp.primaryYAxis.labelStyle.size !== '0px') {
                pYAxisLSize = chartComp.primaryYAxis.labelStyle.size;
            }
        }
        if (switchRowColumn) {
            this.switchRowColumn(chartCollId, chartId, chartComp, currCellObj);
        }
        if (chartType) {
            this.switchChartType(chartCollId, chartId, chartType, chartComp, currCellObj, args.markerVisible);
        }
        if (chartTheme) {
            this.switchChartTheme(chartCollId, chartId, chartTheme, chartComp, currCellObj);
        }
        if (addChartEle) {
            var chartModel = currCellObj.chart[chartCollId];
            var isBarChart = chartModel && chartModel.type.includes('Bar');
            if (opensTitleDialog && !args.title) {
                if (this.parent.element.getElementsByClassName('e-title-dlg').length > 0) {
                    return;
                }
                else {
                    this.titleDlgHandler(addChartEle, chartComp, currCellObj, chartCollId, isAccumulationChart, address, args.triggerEvent, isBarChart);
                }
            }
            else {
                this.updateChartElement(addChartEle, chartComp, currCellObj, chartCollId, args.title, pXAxisLSize, pYAxisLSize, isAccumulationChart, isBarChart);
            }
        }
        if (args.triggerEvent && !opensTitleDialog) {
            var eventArgs = {
                switchRowColumn: args.switchRowColumn, chartType: args.chartType, chartMarker: args.markerVisible,
                chartTheme: args.chartTheme, addChartEle: args.addChartEle, id: overlayElem.id, address: address,
                pXAxisLSize: pXAxisLSize, pYAxisLSize: pYAxisLSize
            };
            this.parent.notify(completeAction, { action: 'chartDesign', eventArgs: eventArgs });
        }
    };
    SpreadsheetChart.prototype.switchRowColumn = function (chartCollId, chartId, chartComp, cell) {
        var chart = this.parent.chartColl[chartCollId];
        chart.isSeriesInRows = isNullOrUndefined(chart.isSeriesInRows) ? true : !chart.isSeriesInRows;
        for (var idx = 0, chartCount = cell.chart.length; idx < chartCount; idx++) {
            if (cell.chart[idx].id === chartId) {
                cell.chart[idx].isSeriesInRows = chart.isSeriesInRows;
            }
        }
        var chartSeries = this.initiateChartHandler({ option: chart, isRefresh: true, isSwitchRowColumn: true });
        chartComp.series = chartSeries;
        chartComp.refresh();
    };
    SpreadsheetChart.prototype.switchChartTheme = function (chartCollId, chartId, theme, chartComp, cell) {
        this.parent.chartColl[chartCollId].theme = theme;
        for (var idx = 0, chartCount = cell.chart.length; idx < chartCount; idx++) {
            if (cell.chart[idx].id === chartId) {
                cell.chart[idx].theme = theme;
            }
        }
        chartComp.setProperties({ theme: theme, background: this.getThemeBgColor(theme) }, true);
        chartComp.refresh();
    };
    SpreadsheetChart.prototype.getThemeBgColor = function (theme) {
        var bg;
        if (theme.includes('Dark')) {
            switch (theme) {
                case 'MaterialDark':
                    bg = '#383838';
                    break;
                case 'FabricDark':
                    bg = '#242424';
                    break;
                case 'BootstrapDark':
                    bg = '#1b1b1b';
                    break;
                case 'Bootstrap5Dark':
                    bg = '#212529';
                    break;
                case 'TailwindDark':
                    bg = '#1f2937';
                    break;
                case 'Tailwind3Dark':
                    bg = '#111827';
                    break;
                case 'FluentDark':
                    bg = '#1b1a19';
                    break;
                case 'Fluent2Dark':
                    bg = '#292929';
                    break;
                case 'Material3Dark':
                    bg = '#1C1B1F';
                    break;
            }
        }
        else if (theme.includes('HighContrast')) {
            bg = '#000000';
        }
        else {
            bg = '#FFFFFF';
        }
        return bg;
    };
    SpreadsheetChart.prototype.switchChartType = function (chartCollId, chartId, chartType, chartComp, cell, markerVisible, enableMarker, action) {
        var type = this.parent.chartColl[chartCollId].type;
        this.parent.chartColl[chartCollId].type = chartType;
        for (var idx = 0, chartCount = cell.chart.length; idx < chartCount; idx++) {
            if (cell.chart[idx].id === chartId) {
                cell.chart[idx].type = chartType;
                if (!isNullOrUndefined(cell.chart[idx].markerSettings)) {
                    cell.chart[idx].markerSettings.visible = markerVisible;
                }
            }
        }
        if (chartType !== 'Pie' && chartType !== 'Doughnut') {
            if (type === 'Pie' || type === 'Doughnut') {
                if (!isNullOrUndefined(this.parent.chartColl[chartCollId].markerSettings)) {
                    if (markerVisible) {
                        this.parent.chartColl[chartCollId].markerSettings.visible = markerVisible;
                    }
                    else if (action === 'undoRedo') {
                        this.parent.chartColl[chartCollId].markerSettings.visible = enableMarker;
                    }
                    else {
                        this.parent.chartColl[chartCollId].markerSettings.visible = false;
                    }
                }
                else if (markerVisible && (chartType === 'Line' || chartType === 'StackingLine' || chartType === 'StackingLine100')) {
                    this.parent.chartColl[chartCollId].markerSettings = { shape: 'Circle', visible: true, isFilled: false };
                }
                this.changeCharType(chartCollId);
            }
            else {
                if (type !== chartType) {
                    if (chartType === 'Scatter') {
                        var labels = chartComp.primaryXAxis['labels'];
                        if (labels && labels.length > 0 && isNumber(labels[labels.length - 1])) {
                            chartComp.primaryXAxis.valueType = 'Double';
                        }
                    }
                    else if (chartComp.primaryXAxis.valueType === 'Double') {
                        chartComp.primaryXAxis.valueType = 'Category';
                    }
                }
                var chartSeries = chartComp.series;
                var isLineChart = chartType === 'Line' || chartType === 'StackingLine' || chartType === 'StackingLine100';
                for (var idx = 0, len = chartSeries.length; idx < len; idx++) {
                    chartSeries[idx].type = chartType;
                    if (isLineChart) {
                        chartSeries[idx].marker.visible = markerVisible;
                        chartSeries[idx].marker.shape = isNullOrUndefined(chartSeries[idx].marker.shape) ? 'Circle' : chartSeries[idx].marker.shape;
                        if (action === 'undoRedo') {
                            chartSeries[idx].marker.visible = enableMarker;
                        }
                    }
                    else {
                        chartSeries[idx].marker.visible = false;
                    }
                }
                chartComp.series = chartSeries;
                chartComp.refresh();
            }
        }
        else {
            if (type === 'Pie' || type === 'Doughnut') {
                var chartSeries = chartComp.series;
                for (var idx = 0, len = chartSeries.length; idx < len; idx++) {
                    chartSeries[idx].innerRadius = chartType === 'Pie' ? '0%' : '40%';
                }
                chartComp.series = chartSeries;
                chartComp.refresh();
            }
            else {
                this.changeCharType(chartCollId);
            }
        }
    };
    SpreadsheetChart.prototype.getChartElement = function (overlayElem) {
        var chartObj = overlayElem.querySelector('.e-chart');
        if (isNullOrUndefined(chartObj)) {
            chartObj = overlayElem.querySelector('.e-accumulationchart');
        }
        return chartObj;
    };
    SpreadsheetChart.prototype.getChartCollectionId = function (id) {
        var chartCollectionId;
        for (var i = 0, len = this.parent.chartColl.length; i < len; i++) {
            if (id === this.parent.chartColl[i].id) {
                chartCollectionId = i;
            }
        }
        return chartCollectionId;
    };
    SpreadsheetChart.prototype.changeCharType = function (chartCollId) {
        var chartEle = document.getElementById(this.parent.chartColl[chartCollId].id);
        var chartParEle = closest(chartEle, '.e-datavisualization-chart');
        chartParEle.remove();
        this.initiateChartHandler({
            option: this.parent.chartColl[chartCollId], isInitCell: false, triggerEvent: false, isPaste: false,
            isChangeChartType: true
        });
        chartEle = document.getElementById(this.parent.chartColl[chartCollId].id);
        chartParEle = closest(chartEle, '.e-datavisualization-chart');
        if (!chartParEle.classList.contains('e-ss-overlay-active')) {
            chartParEle.classList.add('e-ss-overlay-active');
        }
    };
    SpreadsheetChart.prototype.titleDlgHandler = function (addChartEle, chartComp, currCellObj, chartCollId, isAccumulationChart, address, triggerEvent, isBarChart) {
        var _this = this;
        var title = '';
        if (isAccumulationChart && (addChartEle === 'PHAxisTitle' || addChartEle === 'PVAxisTitle')) {
            return;
        }
        var l10n = this.parent.serviceLocator.getService(locale);
        var dialogInst = this.parent.serviceLocator.getService(dialog);
        dialogInst.show({
            width: 375, showCloseIcon: true, isModal: true, cssClass: 'e-title-dlg',
            header: addChartEle === 'chart_abovechart' ? l10n.getConstant('ChartTitle') : addChartEle ===
                'PHAxisTitle' ? l10n.getConstant('HorizontalAxisTitle') : l10n.getConstant('VerticalAxisTitle'),
            beforeOpen: function () {
                dialogInst.dialogInstance.content = _this.titleDlgContent(addChartEle, chartComp, isBarChart);
                dialogInst.dialogInstance.dataBind();
                _this.parent.element.focus();
            },
            buttons: [{
                    buttonModel: {
                        content: l10n.getConstant('Ok'),
                        isPrimary: true,
                        cssClass: 'e-btn e-clearall-btn e-flat'
                    },
                    click: function () {
                        var dlgCont = _this.parent.element.querySelector('.e-title-dlg').
                            getElementsByClassName('e-title-dlg-content')[0];
                        title = dlgCont.getElementsByTagName('input')[0].value;
                        dialogInst.hide();
                        _this.updateChartElement(addChartEle, chartComp, currCellObj, chartCollId, title, null, null, null, isBarChart, address, triggerEvent);
                    }
                }]
        });
        dialogInst.dialogInstance.refresh();
    };
    SpreadsheetChart.prototype.titleDlgContent = function (addChartEle, chartComp, isBarChart) {
        var l10n = this.parent.serviceLocator.getService(locale);
        var dlgContent = this.parent.createElement('div', { className: 'e-title-dlg-content' });
        var value1Text = this.parent.createElement('span', { className: 'e-header e-top-header' });
        value1Text.innerText = l10n.getConstant('EnterTitle');
        var value1Inp = this.parent.createElement('input', { className: 'e-input', id: 'titleInput', attrs: { type: 'text' } });
        dlgContent.appendChild(value1Text);
        dlgContent.appendChild(value1Inp);
        if (chartComp) {
            if (addChartEle === 'PHAxisTitle') {
                if (isBarChart) {
                    value1Inp.value = chartComp.primaryYAxis.title ? chartComp.primaryYAxis.title : value1Inp.value;
                }
                else {
                    value1Inp.value = chartComp.primaryXAxis.title ? chartComp.primaryXAxis.title : value1Inp.value;
                }
            }
            else if (addChartEle === 'PVAxisTitle') {
                if (isBarChart) {
                    value1Inp.value = chartComp.primaryXAxis.title ? chartComp.primaryXAxis.title : value1Inp.value;
                }
                else {
                    value1Inp.value = chartComp.primaryYAxis.title ? chartComp.primaryYAxis.title : value1Inp.value;
                }
            }
            else {
                value1Inp.value = chartComp.title ? chartComp.title : value1Inp.value;
            }
        }
        return dlgContent;
    };
    SpreadsheetChart.prototype.isNumberOrNot = function (minr, minc, maxr, maxc, sheet) {
        for (var rIdx = minr; rIdx <= maxr; rIdx++) {
            for (var cIdx = minc; cIdx <= maxc; cIdx++) {
                var cell = getCell(rIdx, cIdx, sheet);
                if (cell && cell.value) {
                    if (isNumber(cell.value)) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    /**
     * Removing event listener for success and failure
     *
     * @returns {void} - Removing event listener for success and failure
     */
    SpreadsheetChart.prototype.removeEventListener = function () {
        if (!this.parent.isDestroyed) {
            this.parent.off(initiateChart, this.initiateChartHandler);
            this.parent.off(refreshChartCellObj, this.refreshChartCellObj);
            this.parent.off(refreshChartCellOnInit, this.refreshChartCellObj);
            this.parent.off(refreshChartCellModel, this.refreshChartCellModel);
            this.parent.off(deleteChart, this.deleteChart);
            this.parent.off(clearChartBorder, this.clearBorder);
            this.parent.off(insertChart, this.insertChartHandler);
            this.parent.off(chartRangeSelection, this.chartRangeHandler);
            this.parent.off(chartDesignTab, this.chartDesignTabHandler);
            this.parent.off(undoRedoForChartDesign, this.undoRedoForChartDesign);
            this.parent.off(refreshChart, this.refreshChartData);
        }
    };
    /**
     * To Remove the event listeners.
     *
     * @returns {void} - To Remove the event listeners.
     */
    SpreadsheetChart.prototype.destroy = function () {
        this.removeEventListener();
        this.parent = null;
        this.isDateFormatRange = null;
        this.minDate = null;
        this.maxDate = null;
        this.primaryYAxisFormat = null;
        this.primaryXAxisFormat = null;
        var chartEle = null;
        if (this.chart) {
            chartEle = this.chart.element;
            this.chart.destroy();
        }
        if (chartEle) {
            detach(chartEle);
        }
        this.chart = null;
    };
    /**
     * Get the sheet chart module name.
     *
     * @returns {string} - Get the module name.
     */
    SpreadsheetChart.prototype.getModuleName = function () {
        return 'spreadsheetChart';
    };
    return SpreadsheetChart;
}());
export { SpreadsheetChart };
